import {
    IMPUTHOUR_FORM_TOOGLE_LOADING,
    CLOSE_IMPUTHOUR_FORM,
    OPEN_IMPUTHOUR_FORM,
    EDIT_SELECTED_IMPUTHOUR
} from "../constants";

const initialState = {
    show: false,
    loading: false,
    data: null
};

const imputHoursFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case IMPUTHOUR_FORM_TOOGLE_LOADING:
            return {
                ...state,
                loading: !state.loading
            };
        case CLOSE_IMPUTHOUR_FORM:
            return {
                ...state,
                show: false,
                data: null
            };
        case OPEN_IMPUTHOUR_FORM:
            return {
                ...state,
                show: true,
                data: {}
            };
        case EDIT_SELECTED_IMPUTHOUR:
            return {
                ...state,
                show: true,
                data: action.payload
            };
        default:
            return state;
    }
};

export default imputHoursFormReducer; 